import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tabs, Tab } from '@material-ui/core';
import {
  ScrollTab,
  CrudContent,
  CrudLoker,
  CrudDataPengumuman,
} from '../../components';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

function CenteredTabs({
  titlePengumuman,
  titleDataPengumuman,
  typeDataPengumuman,
}: any) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor='primary'
        textColor='primary'
        centered
      >
        <Tab label={titlePengumuman} />
        <Tab label={titleDataPengumuman} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <CrudLoker title={titlePengumuman} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CrudDataPengumuman
          title={titleDataPengumuman}
          type={typeDataPengumuman}
        />
      </TabPanel>
    </div>
  );
}

const data = [
  {
    tab: 'Berita',
    tabPanel: <CrudContent title='Berita' type={4} />,
  },
  {
    tab: 'Kegiatan',
    tabPanel: <CrudContent title='Kegiatan' type={5} />,
  },
  {
    tab: 'Lowongan Pekerjaan',
    tabPanel: (
      <CenteredTabs
        titlePengumuman='Lowongan Pekerjaan'
        titleDataPengumuman='Form Aplikasi Lowongan'
        typeDataPengumuman={1}
      />
    ),
  },
  {
    tab: 'Pengadaan Barang / Jasa',
    tabPanel: <CrudContent title='Pengadaan Barang / Jasa' type={14} />,
  },
  {
    tab: 'Pengumuman Lainnya',
    tabPanel: <CrudContent title='Pengumuman Lainnya' type={9} />,
  },
];

const RuangBerita = () => <ScrollTab content={data} />;

export default RuangBerita;
